import { type CourseListItem } from '../../courses-api.ts';
import { type PerformancePartner, type PerformancePartnerRow } from '../performance-api.ts';
import { toPercent } from './money.ts';
import { type SessionsServiceSession } from './sessions-service-api.ts';
import { sumTotals } from './totals.ts';

export const buildPartners = (
  completed: SessionsServiceSession[],
  courses: CourseListItem[]
): PerformancePartnerRow[] => {
  const coursesById = new Map(courses.map((course) => [course.id, course]));
  const groups = new Map<
    string,
    { partner: PerformancePartner; sessions: SessionsServiceSession[] }
  >();
  const unassigned: SessionsServiceSession[] = [];

  completed.forEach((session) => {
    const partner = session.course_id ? coursesById.get(session.course_id)?.partner : undefined;

    if (!partner) {
      unassigned.push(session);
      return;
    }

    const group = groups.get(partner.id) ?? {
      partner: { id: partner.id, name: partner.legal_name, logo: partner.logo },
      sessions: [],
    };
    group.sessions.push(session);
    groups.set(partner.id, group);
  });

  const totalWagers = sumTotals(completed).wagers;
  const toRow = (
    partner: PerformancePartnerRow['partner'],
    sessions: SessionsServiceSession[]
  ): PerformancePartnerRow => {
    const totals = sumTotals(sessions);
    return { ...totals, partner, share: toPercent(totals.wagers, totalWagers) };
  };

  const rows = [...groups.values()]
    .map(({ partner, sessions }) => toRow(partner, sessions))
    .sort((a, b) => b.wagers - a.wagers);

  return unassigned.length ? [...rows, toRow(null, unassigned)] : rows;
};
